import Parse from 'parse'

import User from './models/User'
import Appointment from './models/Appointment'
import Promocode from './models/Promocode'
import Service from './models/Service'
import Card from './models/Card'
import Address from './models/Address'
import Category from './models/Category'
import BlockedSchedule from './models/BlockedSchedule'


/*
import Service from './models/Service'
import Request from './models/Request'

import Gift from './models/Gift'
import Batch from './models/Batch'
import Location from './models/Location'
import Address from './models/Address'
import Card from './models/Card'
*/
Parse.Object.registerSubclass('_User', User)
Parse.Object.registerSubclass('Appointment', Appointment)
Parse.Object.registerSubclass('Promocode', Promocode)
Parse.Object.registerSubclass('Service', Service)
Parse.Object.registerSubclass('Card', Card)
Parse.Object.registerSubclass('Address', Address)
Parse.Object.registerSubclass('Category', Category)
Parse.Object.registerSubclass('BlockedSchedule', BlockedSchedule)



/*
Parse.Object.registerSubclass('Service', Service)
Parse.Object.registerSubclass('Request', Request)

Parse.Object.registerSubclass('Gift', Gift)
Parse.Object.registerSubclass('Batch', Batch)
Parse.Object.registerSubclass('Address', Address)
Parse.Object.registerSubclass('Card', Card)
Parse.Object.registerSubclass('Location', Location)*/

Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_APP_KEY)
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL

export default Parse
